(() => {
  'use strict';
  if (!window.customElements || customElements.get('sano-home-rotation')) return;
  customElements.define('sano-home-rotation', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.red = this.querySelector('[data-rotation-image="red"]');
      this.blue = this.querySelector('[data-rotation-image="blue"]');
      this.button = this.querySelector('.sano-home-rotation__pause');
      this.mystery = this.querySelector('[data-rotation-image="mystery"]');
      this.frame = 0;
      if (!this.red || !this.blue || !this.button) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      const options = { signal: this.abort.signal };
      // Reuse the already selected image URL, without another image size.
      const fillRed = () => { if (this.red.complete && this.red.naturalWidth) this.style.setProperty('--sano-red-backdrop', `url("${this.red.currentSrc}")`); };
      this.red.addEventListener('load', fillRed, options);
      fillRed();
      this.motion.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.sync(); } }, options);
      this.button.addEventListener('click', () => {
        this.paused = !this.paused;
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.textContent = '';
        this.button.setAttribute('aria-label', this.paused ? 'Afbeeldingswissel hervatten' : 'Afbeeldingswissel pauzeren');
        this.button.title = this.button.getAttribute('aria-label');
        this.sync();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); }, { threshold: 0.1 });
        this.observer.observe(this);
      } // No observer: retain a stable Red Moon image.
      this.sync();
    }
    async loadBlue() {
      if (this.ready || this.loading || this.failed) return;
      this.loading = true;
      const connection = this.abort;
      try {
        // sizes/srcset before src: let the browser select one suitable resource.
        this.blue.srcset = this.blue.dataset.srcset;
        this.blue.src = this.blue.dataset.src;
        // The third, hidden slide loads only when this gallery is in view.
        if(this.mystery && this.mystery.dataset.src) this.mystery.src=this.mystery.dataset.src;
        await Promise.all([this.red.decode(), this.blue.decode()]);
        if (!this.isConnected || connection.signal.aborted || connection !== this.abort) return;
        this.ready = true;
        this.style.setProperty('--sano-blue-backdrop', `url("${this.blue.currentSrc}")`);
        this.blue.hidden = false;
        if(this.mystery){try{await this.mystery.decode();this.mystery.hidden=false;}catch(_){this.mystery=null;}}
      } catch (_) { this.failed = true; } // Keep the working first image on failure.
      finally { this.loading = false; this.sync(); }
    }
    sync() {
      clearTimeout(this.timer);
      if (!this.abort || this.abort.signal.aborted) return;
      if (this.motion.matches) {
        this.removeAttribute('data-show-blue');
        this.removeAttribute('data-show-mystery');
        if(this.mystery)this.mystery.setAttribute('aria-hidden','true');
        this.red.removeAttribute('aria-hidden');
        this.blue.setAttribute('aria-hidden', 'true');
        this.button.hidden = true;
        return;
      }
      this.button.hidden = !this.ready;
      if (!this.inView || document.hidden) return;
      if (!this.ready) { void this.loadBlue(); return; }
      if (this.paused || this.hovered || this.focused) return;
      this.timer = setTimeout(() => {
        this.frame=(this.frame+1)%(this.mystery?3:2);
        const blue=this.frame===1;
        const mystery=this.frame===2;
        this.toggleAttribute('data-show-blue',blue);
        this.toggleAttribute('data-show-mystery',mystery);
        if(this.mystery)this.mystery.setAttribute('aria-hidden',String(!mystery));
        this.red.setAttribute('aria-hidden', String(this.frame!==0));
        this.blue.setAttribute('aria-hidden', String(!blue));
        this.sync();
      }, 4000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
})();
